// src/store/Campuses/campuses.js
import instance from "../../utils/axios";

// 🔹 Save Campus
export const saveCampus = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/campuses/save", formData);
  return response.data;
};

// 🔹 (Optional) Read Campuses (if needed later)
export const readCampuses = async (_id) => {
  const formData = new URLSearchParams();
  if (_id) formData.append("_id", _id);
  const response = await instance.post("/churches/campuses/read", formData);
  return response.data;
};
export const updateCampus = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/campuses/update", formData);
  return response.data;
};
export const deleteCampus = async (payload) => {
  const formData = new URLSearchParams();
  formData.append("_id", payload._id);
  formData.append("campusObjId", payload.campusObjId);

  const response = await instance.post("/churches/campuses/delete", formData);
  return response.data;
};

// 🔹 Save Campus Gallery (Cover Image)
export const saveCampusGallery = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/campuses/campusgallery/save", formData);
  return response.data;
};

// 🔹 Update Campus Gallery
export const updateCampusGallery = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => formData.append(key, val || ""));
  const response = await instance.post("/churches/campuses/campusgallery/update", formData);
  return response.data;
};

// 🔹 Delete Campus Gallery
export const deleteCampusGallery = async (payload) => {

  const formData = new URLSearchParams();
  formData.append("_id", payload?._id);
  formData.append("campusObjId", payload?.campusObjId);
  formData.append("campusGalleryObjId", payload?.campusGalleryObjId);

  const response = await instance.post("/churches/campuses/campusgallery/delete", formData);
  return response.data;
};

